
var ToonShader = {
    uniforms: {
        "tDiffuse": { value: null },
        //"isToonHue": { value: false },
        //"isToonSaturation": { value: false },
        //"isToonLightness": { value: true },
        "numberOfLevels": { value: 3.0 },
        "offset": { value: 0.3 },
        //"colorFactor": { value: 1 },
    },

    vertexShader: `
        varying vec2 vUv;

        void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
    `,

    fragmentShader:`
        uniform sampler2D tDiffuse;
        //uniform bool isToonHue;
        //uniform bool isToonSaturation;
        //uniform bool isToonLightness;
        uniform float numberOfLevels;
        uniform float offset;
        varying vec2 vUv;

        vec3 rgb2hsv(vec3 c)
        {
            vec4 K = vec4(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);
            vec4 p = mix(vec4(c.bg, K.wz), vec4(c.gb, K.xy), step(c.b, c.g));
            vec4 q = mix(vec4(p.xyw, c.r), vec4(c.r, p.yzx), step(p.x, c.r));

            float d = q.x - min(q.w, q.y);
            float e = 1.0e-10;
            return vec3(abs(q.z + (q.w - q.y) / (6.0 * d + e)), d / (q.x + e), q.x);
        }
        vec3 hsv2rgb(vec3 c)
        {
            vec4 K = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);
            vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);
            return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);
        }

        vec3 nearestLevel(vec3 hsv) 
        {
           float col = hsv.x;
           vec3 result = vec3(hsv.xyz);
           col = hsv.z;
           for (float j = 0.0; j < numberOfLevels; j += 1.0) {
               float s = j*offset;
               float l = (j+1.0)*offset;

               if (col >= s && col <= l) {
                 result.z = l;
                 break;
               }
           }

           return result;
        }

        void main() {
            vec4 texel = texture2D(tDiffuse, vUv);
            if (texel.a <= 0.0) {
                gl_FragColor = texel;
                return;
            }

            vec3 hsv = rgb2hsv(texel.rgb);
            hsv = nearestLevel(hsv);

            vec3 rgb = vec3(0.0, 0.0, 0.0);
            rgb = hsv2rgb(hsv);

            gl_FragColor = vec4(rgb.x, rgb.y, rgb.z, texel.a);  
        }
    `,

};

export { ToonShader };
